import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ChatListToolBoxHome } from '$comp/chat-list-tool-box/components/home'

export function ChatListToolboxModal({ isOpen }: { isOpen: boolean }) {
  const isDesktop = useIsDesktopSize()

  return (
    <BottomDrawer
      isTransparent
      isOpen={isOpen}
      onClose={closeCurrentModal}
      bottomSafeAreaColor="veryLightGray"
      paperProps={{
        sx: isDesktop
          ? {
              margin: 'unset',
              right: 0,
              maxWidth: 360,
            }
          : null,
      }}
    >
      <ChatListToolBoxHome onClose={closeCurrentModal} />
    </BottomDrawer>
  )
}
